// @ts-check

// Re-usable stuff
// This is a new version of the file 4 Nov 2026
// Define a namespace for our stuff so we don't get in the way of anything else
var ShopTheme = ShopTheme || {};

// Warn visitors only on the known impersonating domain, never on the real store or previews.
(function warnAboutCopiedStore() {
	const copiedDomain = "thekidcollective.xyz";
	const hostname = window.location.hostname.toLowerCase().replace(/\.$/, "");
	if (hostname !== copiedDomain && !hostname.endsWith("." + copiedDomain)) return;

	const message = "Warning: this is not the official The Kid Collective website. " +
		"Do not enter payment details or personal information here. " +
		"Our official website is https://thekidcollective.co.uk.";

	function showWarning() {
		if (document.getElementById("tkc-copied-store-warning")) return;

		// Keep the notice self-contained so it does not depend on copied theme CSS.
		const warning = document.createElement("div");
		warning.id = "tkc-copied-store-warning";
		warning.setAttribute("role", "alert");
		warning.style.cssText = "position:fixed!important;top:0!important;left:0!important;" +
			"right:0!important;z-index:2147483647!important;display:block!important;" +
			"box-sizing:border-box!important;max-height:100vh!important;overflow:auto!important;" +
			"padding:24px!important;background:#9b1c1c!important;color:#fff!important;" +
			"font:700 18px/1.5 sans-serif!important;text-align:center!important;";
		warning.appendChild(document.createTextNode(message + " "));

		const link = document.createElement("a");
		link.href = "https://thekidcollective.co.uk/";
		link.textContent = "Visit the official website";
		link.referrerPolicy = "no-referrer";
		link.style.cssText = "display:inline-block!important;color:#fff!important;" +
			"text-decoration:underline!important;padding:8px!important;font:inherit!important;";
		warning.appendChild(link);
		document.body.appendChild(warning);

		// The persistent notice remains after the browser alert is dismissed.
		window.alert(message);
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", showWarning, { once: true });
	} else {
		showWarning();
	}
})();

ShopTheme.Global = {
	DEBUG: false,
	pageUnderlay: document.querySelector("[data-underlay]"),
	pageModal: document.querySelector("[data-modal-container]"),

	toggleVisibility: function (element, isVisible) {
		if (!element) return;
		element.classList.toggle("hidden", !isVisible);
	},

	fixBodyScroll: function (isFixed) {
		document.body.classList.toggle("overflow-hidden", isFixed);
	},

	toggleModal: function (isVisible) {
		const modal = ShopTheme.Global.pageModal;
		const overlay = ShopTheme.Global.pageUnderlay;

		if (!modal || !overlay) return;

		if (isVisible) {
			this.toggleVisibility(modal, true);
			this.toggleVisibility(overlay, true);
			this.fixBodyScroll(true);

			overlay.removeEventListener("click", this.closeModal);
			overlay.addEventListener("click", this.closeModal);
			modal.removeEventListener("click", this.closeModalOnOutsideClick);
			modal.addEventListener("click", this.closeModalOnOutsideClick);
		}

		else {
			overlay.removeEventListener("click", this.closeModal);
			modal.removeEventListener("click", this.closeModalOnOutsideClick);

			this.toggleVisibility(modal, false);
			this.toggleVisibility(overlay, false);
			this.fixBodyScroll(false);

			// Cleanup modal content for performance
			const modalContent = modal.querySelector(
				"[data-modal-container-content]"
			);
			if (modalContent) modalContent.innerHTML = "";
		}
	},

	closeModalOnOutsideClick: function (event) {
		const modal = ShopTheme.Global.pageModal;
		if (event.target === modal) {
			ShopTheme.Global.toggleModal(false);
		}
	},

	closeModal: function () {
		ShopTheme.Global.toggleModal(false);
	},

	toggleOverlay: function (isVisible) {
		const overlay = ShopTheme.Global.pageUnderlay;
		if (!overlay) return;
		this.toggleVisibility(overlay, isVisible);
		this.fixBodyScroll(isVisible);
	},

	toggleCartDrawer: function (isVisible) {
		const cartDrawer = document.getElementById("cartDrawer");
		if (!cartDrawer) return;

		if (this.DEBUG) console.log(`Cart Drawer: ${isVisible ? "Open" : "Close"}`);

		this.toggleVisibility(cartDrawer, isVisible);
		cartDrawer?.classList.toggle("translate-x-full", !isVisible);
		cartDrawer?.classList.toggle("invisible", !isVisible);
		cartDrawer.classList.toggle("invisible", !isVisible);
		this.toggleOverlay(isVisible);
	},

	closeAllOverlayComponents: function () {
		if (this.DEBUG) console.log("Closing all overlay components");

		if (this.pageModal && !this.pageModal.classList.contains("hidden")) {
			this.toggleModal(false);
		}

		const cartDrawer = document.getElementById("cartDrawer");
		if (cartDrawer && !cartDrawer.classList.contains("translate-x-full")) {
			this.toggleCartDrawer(false);
		}

		const mobileMenu = document.querySelector(".mobile-menu");
		if (mobileMenu && mobileMenu.classList.contains("open")) {
			ShopTheme.MobileMenu.toggleMenu(false);
		}
	},
};


ShopTheme.Menu = (function () {
	function hideAllMenus() {
		document.querySelectorAll("ul[data-child-menu]").forEach(function (menu) {
			menu.classList.add("hidden");
		});
	}

	function setupMenuToggle() {
		const underlay = document.querySelector("[data-menu-underlay]");
		let underlayTimeout = null;

		// Function to position underlay below header
		function positionMenuUnderlay() {
			if (!underlay) return;

			const headerGroup = document.querySelector('[data-page-template] > [id*="header-group"], [data-page-template] > [id*="shopify-section-header"]');
			if (headerGroup) {
				const headerHeight = headerGroup.offsetHeight;
				const windowHeight = window.innerHeight;
				underlay.style.top = headerHeight + 'px';
				underlay.style.height = (windowHeight - headerHeight) + 'px';
			}
		}

		document
			.querySelectorAll('li[data-has-child-menu="true"]')
			.forEach(function (menuItem) {
				var childMenu = menuItem.querySelector("ul[data-child-menu]");

				// Ensure childMenu exists
				if (!childMenu) {
					return;
				}

				// Show menu on hover (mouseenter)
				menuItem.addEventListener("mouseenter", function () {
					// Clear any pending underlay timeout
					if (underlayTimeout) {
						clearTimeout(underlayTimeout);
						underlayTimeout = null;
					}

					hideAllMenus(); // Hide other menus before showing this one
          if(!childMenu) return;
          // This is where the menu is shown
					childMenu.classList.remove("hidden");

					// Show underlay positioned below header
					if (underlay) {
						positionMenuUnderlay();
						underlay.classList.remove("hidden");
					}
				});

				// Prevent hiding when moving between parent and child menu
				childMenu.addEventListener("mouseenter", function () {
          if (!childMenu) return;
					childMenu.classList.remove("hidden");
				});

				// Close menu only if mouse truly leaves both parent and submenu
				/** @type {number} */
				let closeTimeout;
				menuItem.addEventListener("mouseleave", (/** @type {MouseEvent} */ event) => {
					// Cast relatedTarget to Node and check containment
					if (event.relatedTarget instanceof Node && !menuItem.contains(event.relatedTarget)) {
				        if (!childMenu) return;
						closeTimeout = setTimeout(() => {
							// Re-check elements before modifying
							if (childMenu) {
								childMenu.classList.add("hidden");
							}
							// Check if any menus are still visible before hiding underlay
							const visibleMenus = document.querySelectorAll('ul[data-child-menu]:not(.hidden)');
							if (visibleMenus.length === 0 && underlay) {
								underlayTimeout = setTimeout(() => {
									underlay.classList.add("hidden");
								}, 50);
							}
						}, 300);
					}
				});

				// Cancel pending close if mouse re-enters
				menuItem.addEventListener("mouseenter", () => {
					if (closeTimeout) {
						clearTimeout(closeTimeout);
						closeTimeout = null;
					}
					if (childMenu && childMenu.classList.contains("hidden")) {
						childMenu.classList.remove("hidden");
						if (underlay) {
							positionMenuUnderlay();
							underlay.classList.remove("hidden");
						}
					}
				});
			});
	}


	function setupDocumentClickListener() {
		document.addEventListener("click", function (event) {
			var isClickInsideMenu =
				event.target.closest("ul[data-child-menu]") ||
				event.target.closest('li[data-has-child-menu="true"]');

			if (!isClickInsideMenu) {
				hideAllMenus();
			}
		});
	}

	function init() {
		setupMenuToggle();
		setupDocumentClickListener();

		// Reposition menu underlay on window resize
		window.addEventListener('resize', function() {
			const menuUnderlay = document.querySelector("[data-menu-underlay]");
			if (menuUnderlay && !menuUnderlay.classList.contains("hidden")) {
				const headerGroup = document.querySelector('[data-page-template] > [id*="header-group"], [data-page-template] > [id*="shopify-section-header"]');
				if (headerGroup) {
					const headerHeight = headerGroup.offsetHeight;
					const windowHeight = window.innerHeight;
					menuUnderlay.style.top = headerHeight + 'px';
					menuUnderlay.style.height = (windowHeight - headerHeight) + 'px';
				}
			}
		});
	}

	// Public API
	return {
		init: init,
	};
})();

ShopTheme.MobileMenu = (function () {
	var underlay,
		menu,
		backButton,
		openMenuButton,
		breadcrumbsContainer,
		menuItems;

	function toggleMenu(open) {
		menu.classList.toggle("open", open);
		ShopTheme.Global.toggleOverlay(open);
		document.body.classList.toggle("overflow-hidden", open);
		if (open) {
			updateBackButton();
		} else {
			closeAllChildMenus();
			updateBreadcrumbs();
		}
	}

	function closeAllChildMenus() {
		const openChildMenus = document.querySelectorAll(".mobile-sub-menu.open");
		openChildMenus.forEach(function (menu) {
			menu.classList.remove("open");
		});
	}

	function updateBackButton() {
		const openSubMenus = document.querySelectorAll(".mobile-sub-menu.open");
		backButton.innerHTML = openSubMenus.length > 0 ? "&lt; Back" : "&#10005;";
	}

	function updateBreadcrumbs(selectedItem) {
		if (selectedItem) {
			const primaryTitle = selectedItem.textContent.trim().split("\n")[0];
			breadcrumbsContainer.innerHTML = `${primaryTitle}`;
		} else {
			const openSubMenus = document.querySelectorAll(".mobile-sub-menu.open");
			const parentMenuItemTitle =
				openSubMenus.length > 0
					? openSubMenus[openSubMenus.length - 1]
							.closest("li")
							.textContent.trim()
							.split("\n")[0]
					: "Home";
			breadcrumbsContainer.innerHTML = `${parentMenuItemTitle}`;
		}
	}

	function handleMenuItemClick(e) {
		e.stopPropagation();
		const menuItem = e.currentTarget;
		if (menuItem.dataset.hasChildMenu === "true") {
			e.preventDefault();
			menuItem.querySelector("[data-mobile-child-menu]").classList.add("open");
		} else {
			toggleMenu(false);
		}
		updateBreadcrumbs(menuItem);
		updateBackButton();
	}

	function handleBackButtonClick() {
		const openSubMenus = document.querySelectorAll(".mobile-sub-menu.open");
		const shouldCloseMenu = openSubMenus.length === 0;
		if (shouldCloseMenu) {
			toggleMenu(false);
		} else {
			openSubMenus[openSubMenus.length - 1].classList.remove("open");
			updateBreadcrumbs();
		}
	}

	function setupEventListeners() {
		openMenuButton.addEventListener("click", () => toggleMenu(true));
		backButton.addEventListener("click", handleBackButtonClick);
		underlay.addEventListener("click", function () {
			if (menu.classList.contains("open")) {
				toggleMenu(false); // Only toggle the menu if it's currently open
			}
		});
		menuItems.forEach((menuItem) =>
			menuItem.addEventListener("click", handleMenuItemClick)
		);
	}

	function init() {
		underlay = document.querySelector("[data-underlay]");
		menu = document.querySelector(".mobile-menu");
		backButton = document.querySelector("[data-back-button]");
		openMenuButton = document.querySelector("[data-open-mobile-menu]");
		breadcrumbsContainer = document.querySelector(".breadcrumbs");
		menuItems = document.querySelectorAll(".mobile-menu-items li");

		if (
			underlay &&
			menu &&
			backButton &&
			openMenuButton &&
			breadcrumbsContainer
		) {
			setupEventListeners();
		}
	}

	// Public API
	return {
		init: init,
	};
})();

ShopTheme.Cart = (function () {
	function addItem(itemId, quantity) {
		var addUrl = (localRoutes.cartAddRoute || "/cart/add") + ".js";

		return fetch(addUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				items: [
					{
						id: itemId,
						quantity: quantity,
					},
				],
				sections:
					"main-cart,header-cart-button,cart-drawer,cart-drawer-footer,header-cart-total",
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: data,
				});
				document.dispatchEvent(cartUpdatedEvent);
				return data; // Return data for the promise chain
			})
			.catch((error) => {
				console.error("Error adding item:", error);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: error,
				});
				document.dispatchEvent(cartUpdatedEvent);
				throw error; // Re-throw error for the promise chain
			});
	}

	function updateItem(itemId, quantity) {
		var updateUrl = (localRoutes.cartUpdateRoute || "/cart/update") + ".js";

		fetch(updateUrl, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				updates: {
					[itemId]: quantity,
				},
				sections:
					"main-cart,header-cart-button,cart-drawer,cart-drawer-footer,header-cart-total",
			}),
		})
			.then((response) => response.json())
			.then((data) => {
				// Additional logic after updating item quantity
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: data,
				});
				document.dispatchEvent(cartUpdatedEvent);
			})
			.catch((error) => {
				console.error("Error updating item:", error);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: error,
				});
				document.dispatchEvent(cartUpdatedEvent);
			});
	}

	function submitForm(formData) {
		var addUrl = (localRoutes.cartAddRoute || "/cart/add") + ".js";

		// Check if submit button has additional items to add
		const submitButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
		const additionalItemsAttr = submitButton ? submitButton.getAttribute('data-additional-items') : null;

		if (additionalItemsAttr) {
			// Parse additional items
			let additionalItems = [];
			try {
				additionalItems = JSON.parse(additionalItemsAttr);
			} catch (e) {
				console.error('Error parsing additional items:', e);
			}

			if (additionalItems.length > 0) {
				// Use JSON API to add multiple items at once
				const productVariantId = formData.get('id');
				const productQuantity = formData.get('quantity') || 1;

				const items = [
					{
						id: productVariantId,
						quantity: parseInt(productQuantity),
					},
					...additionalItems
				];

				if (ShopTheme.Global.DEBUG) console.log('Adding multiple items:', items);

				fetch(addUrl, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						items: items,
						sections: "header-cart-button,cart-drawer,cart-drawer-footer,header-cart-total",
					}),
				})
					.then((response) => response.json())
					.then((data) => {
						if (ShopTheme.Global.DEBUG) console.log("Cart updated with additional items:", data);

						// Clear the additional items attribute after successful add
						submitButton.removeAttribute('data-additional-items');

						// Uncheck donation checkbox if it exists
						const donationCheckbox = document.querySelector('.charity-donation-checkbox');
						if (donationCheckbox) donationCheckbox.checked = false;

						var cartUpdatedEvent = new CustomEvent("cart:updated", {
							detail: data,
						});
						document.dispatchEvent(cartUpdatedEvent);
					})
					.catch((error) => {
						console.error("Error updating cart:", error);
						var cartUpdatedEvent = new CustomEvent("cart:updated", {
							detail: error,
						});
						document.dispatchEvent(cartUpdatedEvent);
					});

				return; // Exit early, we've handled the submission
			}
		}

		// Normal form submission (no additional items)
		formData.append(
			"sections",
			"header-cart-button,cart-drawer,cart-drawer-footer,header-cart-total"
		);
		fetch(addUrl, {
			method: "POST",
			body: formData,
		})
			.then((response) => response.json())
			.then((data) => {
				if (ShopTheme.Global.DEBUG) console.log("Cart updated:", data);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: data,
				});
				document.dispatchEvent(cartUpdatedEvent);
			})
			.catch((error) => {
				console.error("Error updating cart:", error);
				var cartUpdatedEvent = new CustomEvent("cart:updated", {
					detail: error,
				});
				document.dispatchEvent(cartUpdatedEvent);
			});
	}

	return {
		addItem: addItem,
		updateItem: updateItem,
		submitForm: submitForm,
	};
})();

ShopTheme.ProductForm = (function () {
	function init() {
		setupProductFormListener();
	}

	function setupProductFormListener() {
		if (ShopTheme.Global.DEBUG) console.log("Setting up product form listener");
		const productForm = document.querySelector('form[action="/cart/add"]');
		if (productForm) {
			if (ShopTheme.Global.DEBUG) console.log("Product form found");
			productForm.removeEventListener("submit", handleProductFormSubmit);
			productForm.addEventListener("submit", handleProductFormSubmit);
		}
	}

	function handleProductFormSubmit(event) {
		if (ShopTheme.Global.DEBUG) console.log("Product form submitted", event);
		event.preventDefault();
		const formData = new FormData(event.target);
		ShopTheme.Cart.submitForm(formData);
	}

	return {
		init: init,
		setupProductFormListener: setupProductFormListener,
	};
})();

ShopTheme.Cart.updateSections = function (sections, callback) {
	if (!sections) {
		return;
	} else {
		Object.keys(sections).forEach(function (sectionKey) {
			var newSectionHtml = sections[sectionKey];
			var parser = new DOMParser();
			var newSectionDoc = parser.parseFromString(newSectionHtml, "text/html");

			newSectionDoc
				.querySelectorAll("[data-section-target]")
				.forEach(function (newSectionPart) {
					var targetAttr = newSectionPart.getAttribute("data-section-target");
					var currentSectionPart = document.querySelector(
						'[data-section-target="' + targetAttr + '"]'
					);

					if (currentSectionPart) {
						currentSectionPart.replaceWith(newSectionPart);
					}
				});
		});
	}
	ShopTheme.Cart.setupCartEventListeners();
	// Re-initialize charity donation ghost item after cart sections update
	if (typeof ShopTheme.CharityDonation !== 'undefined') {
		ShopTheme.CharityDonation.setupGhostItemListener();
		ShopTheme.CharityDonation.updateGhostItemVisibility();
	}
	if (typeof callback === "function") {
		callback(); // Execute the callback
	}
};

ShopTheme.Product = (function () {
	function init() {
		setupRadioButtons();
		setupOptionSelects();
		setupVariantChangeListener();
		updateSubmitButtonState();
	}

	function setupVariantChangeListener() {
		const variantSelect = document.getElementById("variant-select");
		if (variantSelect) {
			variantSelect.addEventListener("change", function(e) {
				onVariantChange(e);
				// Update add to cart button state
				const addButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
				if (addButton) {
					addButton.disabled = !this.value || this.value === '';
				}
			});
		}
	}

	function onVariantChange() {

		if (allFieldsetsHaveSelection()) {
			const variantSelect = document.getElementById("variant-select");
			const productPageSection = document.querySelector(
				'[data-section-target="main-product"]'
			);
			if (variantSelect) {
				// If the variantSelect exists get its value
				const variantId = variantSelect.value;
				if (ShopTheme.Global.DEBUG)
					console.log("Variant changed to:", variantId);

				// Update the URL with the new variant ID
				if (window.location.pathname.includes("/products/")) {
					if (ShopTheme.Global.DEBUG)
						console.log("Updating URL with variant ID", variantId);
					const newUrl =
						window.location.protocol +
						"//" +
						window.location.host +
						window.location.pathname +
						"?variant=" +
						variantId;
					window.history.replaceState({ path: newUrl }, "", newUrl);
				}

				// Emit custom event for variant change (for swiper navigation)
				const variantChangeEvent = new CustomEvent('variant:changed', {
					detail: { variantId: variantId }
				});
				document.dispatchEvent(variantChangeEvent);

				// Update the sections required when a variant changes
				if (productPageSection) {
					updateProductSection(variantId);
				}
			}
		}
	}

	function updateProductSection(variantId) {
		if (ShopTheme.Global.DEBUG)
			console.log("Updating product section", variantId);

		// Note: We don't destroy the swiper here because it's not inside the section being updated
		// The swiper navigation is handled by the variant:changed event listener

		// Update to use the active section rather than
		const sectionId = document
			.querySelector('[data-section-target="main-product"]')
			.getAttribute("data-sectionId");
		const url = window.location.href + "&section_id=" + sectionId;
		fetch(url)
			.then((response) => response.text())
			.then((html) => {
				const newSection = new DOMParser()
					.parseFromString(html, "text/html")
					.querySelector('[data-section-target="main-product"]');
				const currentSection = document.querySelector(
					'[data-section-target="main-product"]'
				);
				if (currentSection && newSection) {
					currentSection.replaceWith(newSection);
				}
				reattachEventListeners(); // Reattach event listeners to new DOM elements
				updateSubmitButtonState();
			});
	}


	function reattachEventListeners() {
		setupRadioButtons(); // Reattach event listeners for radio buttons
		setupOptionSelects(); // Reattach event listeners for option select dropdowns
		setupVariantChangeListener(); // Reattach the variant change listener
		ShopTheme.Cart.setupCartEventListeners(); // Reattach cart event listeners
		ShopTheme.ProductForm.setupProductFormListener();
		ShopTheme.CharityDonation.setupCheckboxListener(); // Reattach charity donation listener
	}

	function setupRadioButtons() {
		const radioButtons = document.querySelectorAll('input[type="radio"]');
		radioButtons.forEach((radio) => {
			radio.addEventListener("change", onRadioButtonChange);
		});
	}

	function onRadioButtonChange() {
		const selectedOptions = getSelectedOptions();
		const variantSelect = document.getElementById("variant-select");
		const matchingVariant = findMatchingVariant(selectedOptions, variantSelect);
		if (matchingVariant) {
			variantSelect.value = matchingVariant.value;
			variantSelect.dispatchEvent(new Event("change")); // Trigger change event if needed
		}
		updateSubmitButtonState();
	}

	function setupOptionSelects() {
		const optionSelects = document.querySelectorAll('select[data-option-position]');
		optionSelects.forEach((select) => {
			// Remove existing listeners to prevent duplicates
			select.removeEventListener("change", onOptionSelectChange);
			select.removeEventListener("blur", onOptionSelectBlur);
			select.removeEventListener("focus", onOptionSelectFocus);

			// Add listeners
			select.addEventListener("change", onOptionSelectChange);
			select.addEventListener("blur", onOptionSelectBlur);
			select.addEventListener("focus", onOptionSelectFocus);
		});
	}

	let safariSelectTimeout = null;

	function onOptionSelectFocus(e) {
		// Cancel any pending section updates when user focuses on a select
		if (safariSelectTimeout) {
			clearTimeout(safariSelectTimeout);
			safariSelectTimeout = null;
		}
	}

	function onOptionSelectBlur(e) {
		// Clear any pending timeout
		if (safariSelectTimeout) {
			clearTimeout(safariSelectTimeout);
		}

		// Check if the user is moving to another select dropdown
		setTimeout(() => {
			const activeElement = document.activeElement;
			const isMovingToAnotherSelect = activeElement &&
				activeElement.tagName === 'SELECT' &&
				activeElement.hasAttribute('data-option-position');

			// If moving to another select, don't update section yet
			if (isMovingToAnotherSelect) {
				return;
			}

			// Set a small delay to ensure Safari select has fully closed before section update
			safariSelectTimeout = setTimeout(() => {
				const selectedOptions = getSelectedOptionsFromSelects();
				const variantSelect = document.getElementById("variant-select");
				const matchingVariant = findMatchingVariant(selectedOptions, variantSelect);
				if (matchingVariant) {
					variantSelect.value = matchingVariant.value;
					variantSelect.dispatchEvent(new Event("change"));
				}
			}, 100);
		}, 0); // Check focus on next tick
	}

	function onOptionSelectChange() {
		const selectedOptions = getSelectedOptionsFromSelects();
		const variantSelect = document.getElementById("variant-select");
		const matchingVariant = findMatchingVariant(selectedOptions, variantSelect);
		if (matchingVariant) {
			variantSelect.value = matchingVariant.value;

			// Emit variant:changed event immediately for instant carousel navigation
			const variantChangeEvent = new CustomEvent('variant:changed', {
				detail: { variantId: matchingVariant.value }
			});
			document.dispatchEvent(variantChangeEvent);
		}
		updateSubmitButtonState();
	}

	function getSelectedOptionsFromSelects() {
		const options = {};
		document.querySelectorAll('select[data-option-position]').forEach((select) => {
			options[select.name] = select.value;
		});
		return options;
	}

	function getSelectedOptions() {
		const options = {};
		document.querySelectorAll("fieldset").forEach((fieldset) => {
			const checkedRadio = fieldset.querySelector(
				'input[type="radio"]:checked'
			);
			if (checkedRadio) {
				options[checkedRadio.name] = checkedRadio.value;
			}
		});
		return options;
	}

	function findMatchingVariant(selectedOptions, variantSelect) {
		return Array.from(variantSelect.options).find((option) => {
			return Object.keys(selectedOptions).every((key) => {
				const optionKey = "data-variant-" + key;
				return (
					!option.hasAttribute(optionKey) ||
					option.getAttribute(optionKey) === selectedOptions[key]
				);
			});
		});
	}

  function allFieldsetsHaveSelection() {
    const container = document.querySelector(
      '[data-section-target="main-product"]'
    );
    if (!container) return false;

    const fieldsets = Array.from(container.querySelectorAll("fieldset")).filter(
      (fs) => fs.offsetParent !== null
    );

    let allSelected = true;

    fieldsets.forEach((fieldset, i) => {
      const legend =
        fieldset.querySelector("legend")?.textContent?.trim() || `Fieldset ${i}`;
      const checked = fieldset.querySelector('input[type="radio"]:checked');

      if (!checked) allSelected = false;
    });

    return allSelected;
  }


	function updateSubmitButtonState() {
		const submitButton = document.querySelector('input[type="submit"]');
		if (!submitButton) {
			return;
		}
		const allSelected = allFieldsetsHaveSelection();

		// if (!allSelected) {
		//   if (ShopTheme.Global.DEBUG) console.log("Not all selected");
		// } else {
		//   if (ShopTheme.Global.DEBUG) console.log("All selected");
		// }

		submitButton.disabled = !allSelected;
	}

	return {
		init: init,
	};
})();

ShopTheme.QuickBuy = (function () {
	// Quick buy functionality for single variant products only
	function handleQuickBuyButtonClick(e) {
		if (ShopTheme.Global.DEBUG) console.log("Quick buy button clicked");
		e.stopImmediatePropagation();
		const button = e.currentTarget;
		const onlyVariant = button.getAttribute("data-only-variant") === "true";

		if (onlyVariant) {
			e.preventDefault();
			const variantId = button.getAttribute("data-variant-id");
			const btnIcon = button.querySelector('svg');
			const btnText = button.querySelector('span');
			const originalText = btnText ? btnText.textContent : '';

			// Add loading state and start animation
			button.classList.add('quick-add-loading');
			button.disabled = true;
			if (btnIcon) {
				btnIcon.classList.add('quick-add-spin');
			}

			ShopTheme.Cart.addItem(variantId, 1)
				.then(() => {
					// Success animation
					button.classList.remove('quick-add-loading');
					button.disabled = false;

					if (btnIcon) {
						btnIcon.classList.remove('quick-add-spin');
						btnIcon.classList.add('quick-add-success');
					}
					button.classList.add('quick-add-success-btn');

					if (btnText) btnText.textContent = 'Added!';

					// Reset after 2 seconds
					setTimeout(() => {
						if (btnText) btnText.textContent = originalText;
						if (btnIcon) {
							btnIcon.classList.remove('quick-add-success');
						}
						button.classList.remove('quick-add-success-btn');
					}, 2000);
				})
				.catch((error) => {
					// Error state
					console.error('Error adding to cart:', error);
					button.classList.remove('quick-add-loading');
					button.disabled = false;

					if (btnIcon) {
						btnIcon.classList.remove('quick-add-spin');
					}
					if (btnText) btnText.textContent = 'Error';

					setTimeout(() => {
						if (btnText) btnText.textContent = originalText;
					}, 2000);
				});
		}
		// No action needed for multi-variant products, they are now links
	}

	function setupQuickBuyButtonListeners() {
		// Use event delegation to handle dynamically loaded content
		document.removeEventListener("click", handleQuickBuyDelegatedClick);
		document.addEventListener("click", handleQuickBuyDelegatedClick);
	}

	function handleQuickBuyDelegatedClick(e) {
		// Check if the clicked element is a quick buy button
		const button = e.target.closest('[data-quick-buy-button][data-only-variant="true"]');
		if (button) {
			// Set the currentTarget to the button and call the handler
			Object.defineProperty(e, 'currentTarget', {
				value: button,
				writable: false
			});
			handleQuickBuyButtonClick(e);
		}
	}

	function init() {
		setupQuickBuyButtonListeners();
	}

	return {
		init: init,
	};
})();

ShopTheme.Accordion = (function () {
	function initAccordion(container) {
		if (!container) return;

		container.querySelectorAll(".accordion-item").forEach((item) => {
			if (!item.querySelector(".accordion-button")) return;

			item.addEventListener("click", () => {
				const itemClasses = Array.from(item.classList);
				const currentItemClass = itemClasses.find((cls) =>
					cls.startsWith("item-")
				);
				if (!currentItemClass) return;

				const isExpanded = item.getAttribute("aria-expanded") === "true";

				// Collapse all
				container.querySelectorAll(".accordion-item").forEach((i) => {
					if (i.querySelector(".accordion-button")) {
						i.setAttribute("aria-expanded", "false");
					}
				});
				container.querySelectorAll(".accordion-content").forEach((content) => {
					content.classList.add("hidden");
				});

				// Expand current if collapsed
				if (!isExpanded) {
					item.setAttribute("aria-expanded", "true");
					const contentToShow = container.querySelector(
						`.accordion-content.${currentItemClass}`
					);
					if (contentToShow) contentToShow.classList.remove("hidden");
				}
			});
		});
	}

	function init() {
		document.querySelectorAll(".accordion").forEach(initAccordion);
	}

	return {
		initAccordion,
		init,
	};
})();

ShopTheme.CharityDonation = (function () {
	function checkDonationInCart(donationVariantId) {
		// Get current cart
		return fetch('/cart.js')
			.then((response) => response.json())
			.then((cart) => {
				const donationInCart = cart.items.some(
					(item) => item.variant_id === parseInt(donationVariantId)
				);
				return donationInCart;
			})
			.catch((error) => {
				console.error("Error checking cart:", error);
				return false;
			});
	}

	function updateGhostItemVisibility() {
		const ghostItem = document.querySelector('[data-charity-ghost]');
		if (!ghostItem) return;

		const donationVariantId = ghostItem.getAttribute('data-donation-variant-id');
		if (!donationVariantId) return;

		checkDonationInCart(donationVariantId).then((inCart) => {
			if (inCart) {
				// Hide ghost item if donation is already in cart
				ghostItem.style.display = 'none';
			} else {
				// Show ghost item if donation is not in cart
				ghostItem.style.display = 'block';
			}
		});
	}

	function setupGhostItemListener() {
		const addButton = document.querySelector('[data-charity-ghost] .add-donation-btn');
		if (!addButton) return;

		// Remove existing listener to prevent duplicates
		addButton.removeEventListener('click', handleGhostItemAdd);
		addButton.addEventListener('click', handleGhostItemAdd);
	}

	function handleGhostItemAdd(event) {
		const button = event.currentTarget;
		const variantId = button.getAttribute('data-variant-id');

		if (!variantId) return;

		// Disable button during processing
		button.disabled = true;
		const originalText = button.textContent;
		button.textContent = 'Adding...';

		// Add donation to cart
		ShopTheme.Cart.addItem(variantId, 1)
			.then(() => {
				if (ShopTheme.Global.DEBUG) console.log('Donation added from cart drawer');
				// The cart:updated event will trigger visibility update
			})
			.catch((error) => {
				console.error('Error adding donation:', error);
				button.textContent = originalText;
				button.disabled = false;
			});
	}

	function setupCheckboxListener() {
		const checkbox = document.querySelector('.charity-donation-checkbox');
		if (!checkbox) return;

		const addToCartButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');
		if (!addToCartButton) return;

		// Remove existing listener to prevent duplicates
		checkbox.removeEventListener('change', handleCheckboxChange);
		checkbox.addEventListener('change', handleCheckboxChange);

		// Initialize button state based on current checkbox state
		updateButtonDataAttribute();
	}

	function handleCheckboxChange() {
		updateButtonDataAttribute();
	}

	function updateButtonDataAttribute() {
		const checkbox = document.querySelector('.charity-donation-checkbox');
		const addToCartButton = document.querySelector('form[action="/cart/add"] button[type="submit"]');

		if (!checkbox || !addToCartButton) return;

		const variantId = checkbox.getAttribute('data-variant-id');

		if (checkbox.checked && variantId) {
			// Set data attribute with additional items to add
			addToCartButton.setAttribute('data-additional-items', JSON.stringify([
				{ id: variantId, quantity: 1 }
			]));
		} else {
			// Remove data attribute
			addToCartButton.removeAttribute('data-additional-items');
		}
	}

	function init() {
		setupCheckboxListener();
		setupGhostItemListener();
		updateGhostItemVisibility();

		// Update ghost item visibility when cart is updated
		document.addEventListener('cart:updated', function() {
			setTimeout(() => {
				setupCheckboxListener();
				setupGhostItemListener();
				updateGhostItemVisibility();
			}, 100);
		});
	}

	return {
		init: init,
		setupCheckboxListener: setupCheckboxListener,
		setupGhostItemListener: setupGhostItemListener,
		updateGhostItemVisibility: updateGhostItemVisibility,
	};
})();

ShopTheme.Cart.setupCartEventListeners = function () {
	if (ShopTheme.Global.DEBUG) console.log("Setting up cart event listeners");

	// Event listener for adding items to the cart
	document.querySelectorAll("[data-remove-item]").forEach((button) => {
		button.addEventListener("click", function () {
			const itemId = this.getAttribute("data-remove-item");
			ShopTheme.Cart.updateItem(itemId, 0); // Remove item by setting quantity to 0
		});
	});

	// Event listener for updating item quantities
	document.querySelectorAll("[data-update-item]").forEach((input) => {
		input.addEventListener("change", function () {
			const itemId = this.getAttribute("data-update-item");
			const quantity = parseInt(this.value);
			ShopTheme.Cart.updateItem(itemId, quantity); // Update item quantity
		});
	});

	document
		.querySelectorAll("[data-target-quantity-selectors]")
		.forEach((parent) => {
			if (parent.dataset.listenersAttached === "true") return; // ✅ Prevent duplicate listeners

			parent.addEventListener("click", function (event) {
				const button = event.target;
				let quantityInput;

				if (button.classList.contains("increase-quantity")) {
					// Find the next sibling input for the increase button
					quantityInput = button.previousElementSibling;
				} else if (button.classList.contains("decrease-quantity")) {
					// Find the previous sibling input for the decrease button
					quantityInput = button.nextElementSibling;
				}

				// Proceed only if a quantityInput was identified
				if (
					quantityInput &&
					quantityInput.classList.contains("quantity-item")
				) {
					let currentQuantity = parseInt(quantityInput.value);
					const maxQuantity =
						parseInt(quantityInput.getAttribute("max")) || Infinity;
					const minQuantity = parseInt(quantityInput.getAttribute("min")) || 1;

					if (
						button.classList.contains("increase-quantity") &&
						currentQuantity < maxQuantity
					) {
						currentQuantity++;
					} else if (
						button.classList.contains("decrease-quantity") &&
						currentQuantity > minQuantity
					) {
						currentQuantity--;
					}

					quantityInput.value = currentQuantity;
					// Trigger change event on the input
					quantityInput.dispatchEvent(new Event("change"));
				}
			});

			parent.dataset.listenersAttached = "true"; // ✅ Mark as initialized
		});
};

ShopTheme.Global.setupGlobalEventListeners = function () {
	// Event listener for closing the cart drawer
	var buttonSelectors = ["continueShopping", "closeCartDrawer"];
	buttonSelectors.forEach(function (selector) {
		var button = document.getElementById(selector);
		if (button) {
			button.addEventListener("click", function () {
				ShopTheme.Global.toggleCartDrawer(false);
			});
		}
	});

	ShopTheme.Global.pageUnderlay.addEventListener("click", function () {
		ShopTheme.Global.closeAllOverlayComponents();
	});

	var cartToggleButtons = document.querySelectorAll("[data-toggle-cart]");
	cartToggleButtons.forEach(function (button) {
		button.addEventListener("click", function (e) {
			e.preventDefault();
			// This prevents the click from immediately closing the drawer because it's outside of the cart drawer
			e.stopPropagation();
			ShopTheme.Global.toggleCartDrawer(true);
		});
	});

	function isCartPage() {
		return window.location.pathname.includes("/cart");
	}

document.addEventListener("cart:updated", function (event) {
	ShopTheme.Cart.updateSections(event.detail.sections, function () {
		if (!isCartPage()) {
			ShopTheme.Global.toggleCartDrawer(true);
		}

		// ✅ Wait for QuickBuy to potentially close the modal first
		setTimeout(() => {
			const overlay = document.querySelector("[data-underlay]");
			const cartDrawer = document.getElementById("cartDrawer");
			const isCartDrawerOpen =
				cartDrawer && !cartDrawer.classList.contains("translate-x-full");

			if (overlay && isCartDrawerOpen) {
				overlay.classList.remove("hidden");
				if (ShopTheme.Global.DEBUG) console.log("Overlay visible (forced)");
			}
		}, 10); // Delay allows QuickBuy listener to run first
	});
});


  document.addEventListener("sectionRender:collection", (event) => {
    ShopTheme.ProductSwiper.init();
	});

};

ShopTheme.SwiperManager = (function () {
  let swiperInstances = new Map();

  function destroySwiper(selector) {
    if (swiperInstances.has(selector)) {
      const swiperInstance = swiperInstances.get(selector);
      if (swiperInstance && typeof swiperInstance.destroy === 'function') {
        swiperInstance.destroy(true, true);
        swiperInstances.delete(selector);
        if (ShopTheme.Global.DEBUG) console.log('Destroyed swiper:', selector);
      }
    }
  }

  function createSwiper(selector, options) {
    // Destroy existing instance if it exists
    destroySwiper(selector);

    const element = document.querySelector(selector);
    if (element) {
      const swiperInstance = new Swiper(selector, options);
      swiperInstances.set(selector, swiperInstance);
      if (ShopTheme.Global.DEBUG) console.log('Created swiper:', selector);
      return swiperInstance;
    }
    return null;
  }

  function initializeSimpleCarousel(sectionId) {
    const selector = `#${sectionId} .swiper`;
    const swiperElement = document.querySelector(selector);
    const flushId = document.querySelector(`#${sectionId} #simple_carousel`);
    let flushSpace = 5;
    if (flushId && flushId.classList.contains('my-16')) {
      flushSpace = 30;
    }

    // Check if pagination and navigation should be shown
    const showPagination = swiperElement?.dataset.showPagination === 'true';
    const showNavigation = swiperElement?.dataset.showNavigation === 'true';

    const mobileSlidesParsed = parseFloat(swiperElement?.dataset.mobileSlidesPerView);
    const mobileSlidesPerView = Number.isFinite(mobileSlidesParsed) ? mobileSlidesParsed : 2;

    const swiperConfig = {
      autoHeight: true,
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: mobileSlidesPerView,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: flushSpace,
        },
      },
    };

    // Only add pagination if enabled
    if (showPagination) {
      swiperConfig.pagination = {
        el: `#${sectionId} .swiper-pagination`,
      };
    }

    // Only add navigation if enabled
    if (showNavigation) {
      swiperConfig.navigation = {
        nextEl: `#${sectionId} .swiper-button-next`,
        prevEl: `#${sectionId} .swiper-button-prev`,
      };
    }

    createSwiper(selector, swiperConfig);
  }

  function initializeSimpleProductCarousel(sectionId) {
    const selector = `#${sectionId} .swiper`;
    const swiperElement = document.querySelector(selector);
    const flushId = document.querySelector(`#${sectionId} #simple_product_carousel`);
    let flushSpace = 5;
    if (flushId && flushId.classList.contains('my-16')) {
      flushSpace = 30;
    }

    // Check if pagination and navigation should be shown
    const showPagination = swiperElement?.dataset.showPagination === 'true';
    const showNavigation = swiperElement?.dataset.showNavigation === 'true';

    const swiperConfig = {
      autoHeight: true,
      loop: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 5,
        },
        768: {
          slidesPerView: 5,
          spaceBetween: flushSpace,
        },
      },
    };

    // Only add pagination if enabled
    if (showPagination) {
      swiperConfig.pagination = {
        el: `#${sectionId} .swiper-pagination`,
      };
    }

    // Only add navigation if enabled
    if (showNavigation) {
      swiperConfig.navigation = {
        nextEl: `#${sectionId} .swiper-button-next`,
        prevEl: `#${sectionId} .swiper-button-prev`,
      };
    }

    createSwiper(selector, swiperConfig);
  }

  function initializeProductSwipers() {
    const productCards = document.querySelectorAll(".product-card");

    productCards.forEach((card) => {
      const productId = card.dataset.productId;
      const selector = `.product-swiper-${productId}`;
      const container = card.querySelector('.product-image-container');

      if (container) {
        const firstImage = container.querySelector('.product-first-image');
        const swiperElement = container.querySelector('.swiper');

        // Only enhance if swiper element exists and is hidden
        if (swiperElement && firstImage && swiperElement.classList.contains('hidden')) {
          const swiperInstance = createSwiper(selector, {
            lazy: true,
            loop: true,
            nested: true,
            spaceBetween: 10,
            touchStartPreventDefault: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            on: {
              init: function () {
                // Once swiper is initialized, hide first image and show swiper
                firstImage.style.display = 'none';
                swiperElement.classList.remove('hidden');
              }
            }
          });
        }
      } else {
        // Fallback for existing cards without progressive loading
        createSwiper(selector, {
          lazy: true,
          loop: true,
          nested: true,
          spaceBetween: 10,
          touchStartPreventDefault: false,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        });
      }
    });
  }

  function initializeHeroBanner(sectionId) {
    const selector = `#${sectionId} .swiper`;
    const swiperElement = document.querySelector(selector);

    // Only initialize if there's more than one slide
    if (swiperElement && swiperElement.getAttribute('data-section-blocks-size') > 1) {
      createSwiper(selector, {
        autoHeight: false,
        loop: true,
        pagination: {
          el: `#${sectionId} .swiper-pagination`,
        },
        navigation: {
          nextEl: `#${sectionId} .swiper-button-next`,
          prevEl: `#${sectionId} .swiper-button-prev`,
        },
      });
    }
  }

  function initializeAnnouncementBar(sectionId) {
    const selector = `#${sectionId} .swiper`;

    createSwiper(selector, {
      autoHeight: true,
      autoplay: {
        delay: 2000,
      },
      loop: true,
      navigation: {
        nextEl: `#${sectionId} .swiper-button-next`,
        prevEl: `#${sectionId} .swiper-button-prev`,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
    });
  }


  function initializeSectionSwipers(sectionElement) {
    const sectionId = sectionElement.id;

    // Check what type of section this is and initialize appropriate swipers
    if (sectionElement.querySelector('#simple_carousel')) {
      initializeSimpleCarousel(sectionId);
    }

    if (sectionElement.querySelector('#simple_product_carousel')) {
      initializeSimpleProductCarousel(sectionId);
    }

    if (sectionElement.querySelector('.product-card')) {
      initializeProductSwipers();
    }

    // Check for hero banner (has .hero.swiper with data-section-blocks-size)
    if (sectionElement.querySelector('.hero.swiper[data-section-blocks-size]')) {
      initializeHeroBanner(sectionId);
    }

    // Check for announcement bar (has .announcement-bar class)
    if (sectionElement.classList.contains('announcement-bar') || sectionElement.querySelector('.announcement-bar')) {
      initializeAnnouncementBar(sectionId);
    }
  }

  function initializeAllSwipers() {
    // Initialize all existing swipers on page load
    document.querySelectorAll('[id^="shopify-section-"]').forEach((section) => {
      initializeSectionSwipers(section);
    });
  }

  function handleSectionLoad(event) {
    if (ShopTheme.Global.DEBUG) console.log('Section loaded:', event.detail.sectionId);
    const sectionElement = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (sectionElement) {
      initializeSectionSwipers(sectionElement);
    }
  }

  function handleSectionUnload(event) {
    if (ShopTheme.Global.DEBUG) console.log('Section unloaded:', event.detail.sectionId);
    const sectionId = `shopify-section-${event.detail.sectionId}`;

    // Destroy all swipers in this section
    swiperInstances.forEach((instance, selector) => {
      if (selector.includes(`#${sectionId}`)) {
        destroySwiper(selector);
      }
    });
  }

  function handleSectionSelect(event) {
    if (ShopTheme.Global.DEBUG) console.log('Section selected:', event.detail.sectionId);
    // Reinitialize swipers when section is selected in theme editor
    const sectionElement = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (sectionElement) {
      initializeSectionSwipers(sectionElement);
    }
  }

  function handleSectionDeselect(event) {
    if (ShopTheme.Global.DEBUG) console.log('Section deselected:', event.detail.sectionId);
  }

  function handleBlockSelect(event) {
    if (ShopTheme.Global.DEBUG) console.log('Block selected:', event.detail.blockId);
    // Reinitialize swipers when block is selected
    const sectionElement = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    if (sectionElement) {
      initializeSectionSwipers(sectionElement);
    }
  }

  function handleBlockDeselect(event) {
    if (ShopTheme.Global.DEBUG) console.log('Block deselected:', event.detail.blockId);
  }

  function init() {
    initializeAllSwipers();

    // Listen to Shopify theme editor events
    document.addEventListener('shopify:section:load', handleSectionLoad);
    document.addEventListener('shopify:section:unload', handleSectionUnload);
    document.addEventListener('shopify:section:select', handleSectionSelect);
    document.addEventListener('shopify:section:deselect', handleSectionDeselect);
    document.addEventListener('shopify:block:select', handleBlockSelect);
    document.addEventListener('shopify:block:deselect', handleBlockDeselect);

    // Also listen for collection render events
    document.addEventListener("sectionRender:collection", initializeProductSwipers);
  }

  return {
    init: init,
    initializeAllSwipers: initializeAllSwipers,
    initializeProductSwipers: initializeProductSwipers,
    createSwiper: createSwiper,
    destroySwiper: destroySwiper
  };
})();

// Keep ProductSwiper for backward compatibility
ShopTheme.ProductSwiper = (function () {
  function initializeSwipers() {
    ShopTheme.SwiperManager.initializeProductSwipers();
  }

  function init() {
    // Delegate to SwiperManager
    ShopTheme.SwiperManager.init();
  }

  return {
    init: init,
    initializeSwipers: initializeSwipers
  };
})();


document.addEventListener("DOMContentLoaded", function () {
	ShopTheme.Global.setupGlobalEventListeners();
	ShopTheme.Cart.setupCartEventListeners();
	ShopTheme.Product.init();
	ShopTheme.ProductForm.init();
	ShopTheme.Menu.init();
	ShopTheme.MobileMenu.init();
	ShopTheme.QuickBuy.init();
  ShopTheme.SwiperManager.init();
  ShopTheme.Accordion.init();
  ShopTheme.CharityDonation.init();
});
